import React, { useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { MdNotificationsNone } from "react-icons/md";
import NotificationDropdown from "./NotificationDropdown";
import Dropdown from "./Dropdown";
import "../../styles/Navbar.css";

const Navbar = () => {
  const [profileImgClicked, setProfileImgClicked] = useState(false);
  const [notificationIconClicked, setNotificationIconClicked] = useState(false);
  const location = useLocation();

  const closeNotificationBox = () => {
    setNotificationIconClicked(false);
  };

  // const getNotification = async () => {
  //   setNotificationIconClicked(!notificationIconClicked);
  //   const data = await notificationData({ token });
  // };

  // The top header bar is shown on the Dashboard only; every other page
  // uses the full height (Logout lives in the sidebar).
  if (location.pathname !== "/dashboard") return null;

  return (
    <div className="navbar-container">
      <div className="navbar-icon-container">
        {/* <div className="dropdown">
          <MdNotificationsNone
            onClick={() => {
              setNotificationIconClicked(!notificationIconClicked);
              setProfileImgClicked(false);
            }}
          />
          {notificationIconClicked && (
            <NotificationDropdown closeNotificationBox={closeNotificationBox} />
          )}
        </div> */}
        <div
          className="dropdown"
          onClick={() => {
            setNotificationIconClicked(false);
            setProfileImgClicked(!profileImgClicked);
          }}
        >
          <FaUserCircle />
          {profileImgClicked && <Dropdown />}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
